import { useState } from 'react';
import type React from 'react';
import { MenuDropdown, MenuDropdownItem } from '../../components/popup/MenuDropdown';

interface DeleteMenuDropdownProps {
  trigger: React.ReactNode;
  dropdownClassName: string;
  onDelete: () => void | Promise<void>;
  triggerAriaLabel?: string;
  stopPropagationOnMouseDown?: boolean;
  menuItemLabel?: string;
}

export const DeleteMenuDropdown = ({
  trigger,
  dropdownClassName,
  onDelete,
  triggerAriaLabel = '메뉴 열기',
  stopPropagationOnMouseDown = false,
  menuItemLabel = '삭제하기'
}: DeleteMenuDropdownProps) => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <>
      <button
        type="button"
        aria-label={triggerAriaLabel}
        onMouseDown={stopPropagationOnMouseDown ? (e) => e.stopPropagation() : undefined}
        onClick={() => setIsOpen((prev) => !prev)}
      >
        {trigger}
      </button>
      {isOpen && (
        <MenuDropdown className={dropdownClassName} onClickOutside={() => setIsOpen(false)}>
          <MenuDropdownItem onClick={onDelete}>{menuItemLabel}</MenuDropdownItem>
        </MenuDropdown>
      )}
    </>
  );
};
